module.exports = __webpack_public_path__ + "static/official_blog-f26d1a8f5f9d155214891b223990af70.jpg";